import React, { lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";

// Components
const Login = lazy(() =>
  import(/* webpackChunkName: "Login" */ "../components/Login/Login")
);
import CustomMeta from "../components/CustomMeta/CustomMeta";

// redux stuff
import { connect } from "react-redux";

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
}));

function login() {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Login to Content Generator`}
        description={`Access your Content Generator account to create and manage your marketing content. Sign in to your dashboard for post creation, video generation, and marketing tools.`}
        url={`https://contentgenerator.io/login`}
      />
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <Login />
        </Suspense>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(login);
